module.exports = __webpack_public_path__ + "static/media/125327233_10222831927082161_6440974222704808100_n.c13448a5.jpg";